import React, { useRef } from 'react';
import ReactDOM from 'react-dom';

const ClipboardProvider = (props) => {
  const { children } = props;
  const copyTarget = useRef(null);

  const copy = (value) => {
    const parent = document.body;
    const container = document.createElement('div');
    container.style.cssText =
      'position:fixed; bottom: 0; right: 0; width:1; height:1; opacity: 0; overflow: hidden;';
    const input = <input ref={copyTarget} value={value} readOnly />;
    parent.appendChild(container);
    ReactDOM.render(input, container);
    copyTarget.current.select();
    document.execCommand('copy');
    ReactDOM.unmountComponentAtNode(container);
    parent.removeChild(container);
  };

  return children({ copy });
};

export default ClipboardProvider;
